import { render, staticRenderFns } from "./supplydemandinfo.vue?vue&type=template&id=5dd5678e&scoped=true&"
import script from "./supplydemandinfo.vue?vue&type=script&lang=js&"
export * from "./supplydemandinfo.vue?vue&type=script&lang=js&"
import style0 from "./supplydemandinfo.vue?vue&type=style&index=0&id=5dd5678e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd5678e",
  null
  
)

export default component.exports